// extracted by mini-css-extract-plugin
export default {"container":"Fq-z","heading":"Gq-z","text":"Hq-z","info":"Iq-z","link":"Jq-z","fullMaxWidth":"Kq-z"};